import { render, staticRenderFns } from "./Orientacoes.vue?vue&type=template&id=220b5c13"
import script from "./Orientacoes.vue?vue&type=script&lang=js"
export * from "./Orientacoes.vue?vue&type=script&lang=js"
import style0 from "./Orientacoes.vue?vue&type=style&index=0&id=220b5c13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports